module.exports = __webpack_public_path__ + "img/T4-D-xs_10.64108ded.png";